import styled from 'styled-components';

export const RfidUploadedFilesListContainerStyle = styled.div`
  .button-group {
    display: flex;
    padding: 5px 35px;
  }
`;
